<template>
  <div class="order-card">
    <div class="order-header">
      <span class="order-type" :class="orderTypeClass">{{ orderTypeText }}</span>
      <span class="order-status" :class="statusClass">{{ statusText }}</span>
    </div>
    <div class="order-body">
      <div class="order-row">
        <span class="label">预约单号</span>
        <span class="value">{{ order.appointmentNo || order.appointmentNumber || '-' }}</span>
      </div>
      <div class="order-row">
        <span class="label">预约时间</span>
        <span class="value">{{ timeInfo.value }}</span>
      </div>
      <div class="order-row" v-if="order.plateNo">
        <span class="label">车牌号</span>
        <span class="value">{{ order.plateNo }}</span>
      </div>
      <div class="order-row" v-if="order.cargoName">
        <span class="label">货物</span>
        <span class="value">{{ order.cargoName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderCard',
  props: {
    order: { type: Object, required: true },
  },
  computed: {
    orderTypeText() {
      const type = this.order.type || this.order.appointmentType;
      if (type === 'PICKUP' || type === 0 || type === '0') return '提货';
      if (type === 'DELIVERY' || type === 1 || type === '1') return '卸货';
      return '预约';
    },
    orderTypeClass() {
      return this.orderTypeText === '提货' ? 'pickup' : 'delivery';
    },
    statusText() {
      const statusMap = {
        1: '进行中',
        2: '进行中',
        5: '待入场',
        6: '待作业',
        7: '作业中',
      };
      const status = typeof this.order.status === 'number' ? this.order.status : Number(this.order.status);
      return statusMap[status] || '进行中';
    },
    statusClass() {
      return 'in-progress';
    },
    timeInfo() {
      const order = this.order;
      const start = this.extractTime(order.actualStartTime);
      const end = this.extractTime(order.actualEndTime);
      if (start && end) {
        return { label: '实际时间', value: `${start} - ${end}` };
      }
      if (start && !end) {
        return { label: '实际时间', value: `${start} 起` };
      }
      if (!start && end) {
        return { label: '实际时间', value: `至 ${end}` };
      }
      return { label: '预约时间', value: order.appointmentTimeSlot || order.appointmentDate || '-' };
    },
  },
  methods: {
    extractTime(value) {
      if (!value) return '';
      const str = String(value).trim();
      const m = str.match(/^(\d{1,2}):(\d{1,2})(?::\d{1,2})?$/);
      if (!m) return '';
      return `${m[1].padStart(2, '0')}:${m[2].padStart(2, '0')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.order-type {
  font-size: 14px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
}
.order-type.pickup { color: #1989fa; background: #e8f4ff; }
.order-type.delivery { color: #07c160; background: #e8f8ef; }
.order-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}
.order-status.in-progress { color: #ff976a; background: #fff0e8; }
.order-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 6px;
}
.order-row .label {
  color: #999;
}
.order-row .value {
  color: #333;
}
</style>
